const UIScreens = () => {
  return (
    <section className="flex h-[900px] items-center justify-center" data-cy="ui-screens">
      <div className="h-9/12 w-1/6 rounded-2xl bg-blue-950" />
      <div className="h-10/12 w-1/6 rounded-2xl bg-slate-900" />
      <div className="h-11/12 w-1/6 rounded-2xl bg-cyan-950" />
      <div className="h-10/12 w-1/6 rounded-2xl bg-slate-900" />
      <div className="h-9/12 w-1/6 rounded-2xl bg-blue-950" />
    </section>
  );
};

export default UIScreens;
